export var WebhookErrorType;
(function (WebhookErrorType) {
    WebhookErrorType["TIMEOUT"] = "TIMEOUT";
    WebhookErrorType["RESOLVE_ERROR"] = "RESOLVE_ERROR";
    WebhookErrorType["HTTP_ERROR"] = "HTTP_ERROR";
    WebhookErrorType["DECRYPTION_ERROR"] = "DECRYPTION_ERROR";
    WebhookErrorType["UNKNOWN"] = "UNKNOWN";
})(WebhookErrorType || (WebhookErrorType = {}));
export class WebhookError {
    code;
    type;
    description;
}
//# sourceMappingURL=webhook-error.js.map